<script setup>
import { ref, onMounted, onUnmounted, defineExpose, nextTick } from 'vue';
import {formatTimes} from '@/utils/other'
import {useRouter} from "vue-router";

const router = useRouter();
const list = ref([]), info = ref({})
let observer = null;

function getInfo(e, data) {
  list.value = []
  e.map(item => {
    item.time = formatTimes(item.createTime)
    list.value.push(item)
  })
  info.value = data

  // 数据更新后重新设置观察器
  nextTick(() => {
    setTimeout(() => {
      if (observer) {
        observer.disconnect()
      }

      observer = new IntersectionObserver(
          (entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                entry.target.classList.add('animate__fadeInUp');
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
      );

      // 延迟执行以确保DOM渲染完成
      setTimeout(() => {
        document.querySelectorAll('.thumblist2 li').forEach(el => {
          observer.observe(el);
        });
      }, 50);
    }, 50)
  })
}

function goDetails(item) {
  router.push({
    path: `/newsDetails`,
    query: { id: item.id }
  })
}

onMounted(() => {
  // 初始化 IntersectionObserver
  observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate__fadeInUp');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
  );

  // 延迟执行以确保DOM渲染完成
  setTimeout(() => {
    document.querySelectorAll('.thumblist2 li').forEach(el => {
      observer.observe(el);
    });
  }, 100);
});

onUnmounted(() => {
  if (observer) {
    observer.disconnect()
  }
});

// 暴露方法给父组件调用
defineExpose({
  getInfo
})
</script>

<template>
  <div id="floor_4_main">
    <div id="floor_4">
      <div class="left_title1">
        <h2><a href="javascript:;">{{ info.name}}</a></h2>
        <p>{{info.remark}}</p>
        <i></i>
      </div>
      <!-- 使用 v-for 循环渲染新闻列表 -->
      <div class="left_body1">
        <ul class="thumblist2">
          <li v-for="(news, index) in list" :key="news.id" class="animate__animated " :class="['n' + (index % 2)]" @click="goDetails(news)">
            <div class="pointer">
              <div class="InfoTime">
                <div class="d">{{ news.time.day }}</div>
                <div class="y-m">{{ news.time.date }}</div>
              </div>
              <div class="InfoPicture">
                <img :src="news.picUrl" :alt="news.title" :title="news.title">
              </div>
              <div class="InfoWrap">
                <span class="InfoTitle">{{ news.title }}</span>
                <p>{{ news.introduction }}</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="left_bottom1"></div>
    </div>
  </div>
</template>

<style scoped lang="scss">
#floor_4_main {
  background: url("@/assets/images/fubj.jpg");
  background-size: 100% 100%;
}

/* 确保你的 .thumblist2 li 初始状态是隐藏的 */
.thumblist2 li {
  opacity: 0;
  transform: translateY(30px);

  &.animate__fadeInUp {
    opacity: 1;
    transform: translateY(0);
    animation-name: fadeInUp;
    animation-duration: 0.6s;
  }
}
</style>